import React, {useState} from 'react';
import {NotificationManager} from 'react-notifications';
import {useHistory} from "react-router-dom";
import {Container} from "react-bootstrap";
import {useAuth} from 'contexts/authContext';
import {updateUserAccount} from 'services/users';
import {useTranslation} from "react-i18next";
import {normalizeLanguage} from "../../utils";

// React Components
import Form from './Form';
import Header from 'components/Header/Header';

// CSS Files
import './styles.css';

const EditAccount = () => {
   const [isSubmittingForm, setIsSubmittingForm] = useState(false);
   const {user, setUser} = useAuth();
   const history = useHistory();
   const { t, i18n } = useTranslation();

   const handleOnSubmit = async values => {
      const {
         email,
         name,
         phone,
         gender,
         password,
         birthyear,
         fppLicence,
         facebook,
         hasSocialMedia,
         hasFppLicence,
         wantsAppNotifications,
         divisionMatches,
         sameDaySameClubMatches,
         unscheduledLeagueMatches,
         language
      } = values;

      const normalizedLanguage = normalizeLanguage(language);

      const auxValues = {
         ...user,
         email,
         name,
         gender,
         birthyear,
         site_url: facebook,
         password,
         social_media: hasSocialMedia,
         fpp_licence: fppLicence,
         phone_number: phone,
         wants_app_notifications: wantsAppNotifications,
         daily_match_notification: divisionMatches,
         match_day_notification: sameDaySameClubMatches,
         matches_to_be_played_notification: unscheduledLeagueMatches,
         language: normalizedLanguage,
         to_log: 'editar_conta'
      };

      if (auxValues.password === "") {
         delete auxValues.password
      }

      if (!hasFppLicence) {
         auxValues.fpp_licence = "";
      }

      let formData = new FormData();
      Object.keys(auxValues).forEach(key => formData.set(key, auxValues[key]));
      setIsSubmittingForm(true);

      try {
         let user = await updateUserAccount(formData, normalizedLanguage);
         auxValues.enrollments = user.enrollments;
         setUser(auxValues);

         await i18n.changeLanguage(normalizedLanguage);

         NotificationManager.success(t("user_profile_page.update_successful"), t("common.success"), 1500);

         setTimeout(function () {
            history.push("/my-games");
         }, 2000);
      } catch (err) {
         if (err.status === 400) {
            NotificationManager.error(t("user_profile_page.errors.active_league_name_change"), t("common.error"), 4000);
         } else {
            NotificationManager.error(t("user_profile_page.errors.update_failed"), t("common.error"), 4000);
         }
      }

      setIsSubmittingForm(false)
   };

   return (
      <div className="EditAccount">
         <Header headerBarTitle={t('user_profile_page.header')} showHeaderExtras>
         </Header>

         <Container>
            {user && (
               <Form
                  user={user}
                  onSubmit={handleOnSubmit}
                  submitting={isSubmittingForm}
               />
            )}
         </Container>
      </div>
   );
};

export default EditAccount;
